import type { NotificationType, ServiceInterestNotificationMetadata } from "@/interfaces";
import { Descriptions, Modal, Tag, Typography } from "antd";
import dayjs from "dayjs";

const { Paragraph, Text } = Typography;

interface NotificationDetailsModalProps {
  notification: NotificationType | null;
  open: boolean;
  onClose: () => void;
}

export function getServiceInterestNotificationMetadata(
  notification: NotificationType | null | undefined,
): ServiceInterestNotificationMetadata | null {
  const metadata = notification?.metadata;
  if (!metadata || typeof metadata !== "object") return null;
  if ((metadata as ServiceInterestNotificationMetadata).eventType !== "service_interest_request") return null;
  return metadata as ServiceInterestNotificationMetadata;
}

export default function NotificationDetailsModal({
  notification,
  open,
  onClose,
}: NotificationDetailsModalProps) {
  const metadata = getServiceInterestNotificationMetadata(notification);

  return (
    <Modal
      title={notification?.title || "Notification Details"}
      open={open}
      onCancel={onClose}
      footer={null}
      width={760}
      destroyOnHidden
    >
      {!notification || !metadata ? null : (
        <div className="space-y-6">
          <Paragraph className="mb-0 text-gray-700">{notification.message}</Paragraph>

          <Descriptions bordered column={1} size="middle">
            <Descriptions.Item label="Client">{metadata.clientName}</Descriptions.Item>
            <Descriptions.Item label="Client User">{metadata.clientUserName}</Descriptions.Item>
            <Descriptions.Item label="Client User Email">
              <Text copyable>{metadata.clientUserEmail}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Service">{metadata.serviceName}</Descriptions.Item>
            <Descriptions.Item label="Service Type">
              {metadata.serviceType ? <Tag color="blue">{metadata.serviceType}</Tag> : "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Service Category">{metadata.serviceCategory || "N/A"}</Descriptions.Item>
            <Descriptions.Item label="Company">{metadata.companyName}</Descriptions.Item>
            <Descriptions.Item label="Requested At">
              {dayjs(metadata.requestedAt || notification.createdAt || notification.date).format("MMM D, YYYY h:mm A")}
            </Descriptions.Item>
            <Descriptions.Item label="Notification Created At">
              {dayjs(notification.createdAt || notification.date).format("MMM D, YYYY h:mm A")}
            </Descriptions.Item>
          </Descriptions>
        </div>
      )}
    </Modal>
  );
}
